import { createSelector } from 'reselect';

export const getFilterConfig = createSelector(
  [
    fieldConfig => fieldConfig,
    (fieldConfig, conditionConfig) => conditionConfig,
    (fieldConfig, conditionConfig, filterData) => filterData,
    (fieldConfig, conditionConfig, filterData, oriData) => oriData
  ],
  (fieldConfig, conditionConfig, filterData, oriData) => {
    if (!fieldConfig) return [];
    return fieldConfig.map(val => {
      if (conditionConfig[val.value] || filterData[val.value]) {
        return Object.assign({ options: { rules: [] } }, val, {
          condition: conditionConfig[val.value] || [],
          metaData: filterData[val.value] || [],
          originalData: oriData[val.value] || []
        });
      }
      return val;
    });
  }
);
